/* eslint-disable */
import { sortBy } from "lodash"


export enum Country {
    Afghanistan = "Afghanistan",
    Albania = "Albania",
    Algeria = "Algeria",
    Andorra = "Andorra",
    Angola = "Angola",
    AntiguaAndDeps = "AntiguaAndDeps",
    Argentina = "Argentina",
    Armenia = "Armenia",
    Australia = "Australia",
    Austria = "Austria",
    Azerbaijan = "Azerbaijan",
    Bahamas = "Bahamas",
    Bahrain = "Bahrain",
    Bangladesh = "Bangladesh",
    Barbados = "Barbados",
    Belarus = "Belarus",
    Belgium = "Belgium",
    Belize = "Belize",
    Benin = "Benin",
    Bhutan = "Bhutan",
    Bolivia = "Bolivia",
    BosniaHerzegovina = "BosniaHerzegovina",
    Botswana = "Botswana",
    Brazil = "Brazil",
    Brunei = "Brunei",
    Bulgaria = "Bulgaria",
    Burkina = "Burkina",
    Burundi = "Burundi",
    Cambodia = "Cambodia",
    Cameroon = "Cameroon",
    Canada = "Canada",
    CapeVerde = "CapeVerde",
    CentralAfricanRep = "CentralAfricanRep",
    Chad = "Chad",
    Chile = "Chile",
    China = "China",
    Colombia = "Colombia",
    Comoros = "Comoros",
    Congo = "Congo",
    CostaRica = "CostaRica",
    Croatia = "Croatia",
    Cuba = "Cuba",
    Cyprus = "Cyprus",
    CzechRepublic = "CzechRepublic",
    Denmark = "Denmark",
    Djibouti = "Djibouti",
    Dominica = "Dominica",
    DominicanRepublic = "DominicanRepublic",
    EastTimor = "EastTimor",
    Ecuador = "Ecuador",
    Egypt = "Egypt",
    ElSalvador = "ElSalvador",
    EquatorialGuinea = "EquatorialGuinea",
    Eritrea = "Eritrea",
    Estonia = "Estonia",
    Ethiopia = "Ethiopia",
    Fiji = "Fiji",
    Finland = "Finland",
    France = "France",
    Gabon = "Gabon",
    Gambia = "Gambia",
    Georgia = "Georgia",
    Germany = "Germany",
    Ghana = "Ghana",
    Greece = "Greece",
    Grenada = "Grenada",
    Guatemala = "Guatemala",
    Guinea = "Guinea",
    GuineaBissau = "GuineaBissau",
    Guyana = "Guyana",
    Haiti = "Haiti",
    Honduras = "Honduras",
    HongKong = "HongKong",
    Hungary = "Hungary",
    Iceland = "Iceland",
    India = "India",
    Indonesia = "Indonesia",
    Iran = "Iran",
    Iraq = "Iraq",
    Ireland = "Ireland",
    Israel = "Israel",
    Italy = "Italy",
    IvoryCoast = "IvoryCoast",
    Jamaica = "Jamaica",
    Japan = "Japan",
    Jordan = "Jordan",
    Kazakhstan = "Kazakhstan",
    Kenya = "Kenya",
    Kiribati = "Kiribati",
    KoreaNorth = "KoreaNorth",
    KoreaSouth = "KoreaSouth",
    Kosovo = "Kosovo",
    Kuwait = "Kuwait",
    Kyrgyzstan = "Kyrgyzstan",
    Laos = "Laos",
    Latvia = "Latvia",
    Lebanon = "Lebanon",
    Lesotho = "Lesotho",
    Liberia = "Liberia",
    Libya = "Libya",
    Liechtenstein = "Liechtenstein",
    Lithuania = "Lithuania",
    Luxembourg = "Luxembourg",
    Macedonia = "Macedonia",
    Madagascar = "Madagascar",
    Malawi = "Malawi",
    Malaysia = "Malaysia",
    Maldives = "Maldives",
    Mali = "Mali",
    Malta = "Malta",
    MarshallIslands = "MarshallIslands",
    Mauritania = "Mauritania",
    Mauritius = "Mauritius",
    Mexico = "Mexico",
    Micronesia = "Micronesia",
    Moldova = "Moldova",
    Monaco = "Monaco",
    Mongolia = "Mongolia",
    Montenegro = "Montenegro",
    Morocco = "Morocco",
    Mozambique = "Mozambique",
    Myanmar = "Myanmar",
    Namibia = "Namibia",
    Nauru = "Nauru",
    Nepal = "Nepal",
    Netherlands = "Netherlands",
    NewZealand = "NewZealand",
    Nicaragua = "Nicaragua",
    Niger = "Niger",
    Nigeria = "Nigeria",
    Norway = "Norway",
    Oman = "Oman",
    Pakistan = "Pakistan",
    Palau = "Palau",
    Panama = "Panama",
    PapuaNewGuinea = "PapuaNewGuinea",
    Paraguay = "Paraguay",
    Peru = "Peru",
    Philippines = "Philippines",
    Poland = "Poland",
    Portugal = "Portugal",
    Qatar = "Qatar",
    Romania = "Romania",
    RussianFederation = "RussianFederation",
    Rwanda = "Rwanda",
    StKittsAndNevis = "StKittsAndNevis",
    StLucia = "StLucia",
    SaintVincentAndTheGrenadines = "SaintVincentAndTheGrenadines",
    Samoa = "Samoa",
    SanMarino = "SanMarino",
    SaoTomeAndPrincipe = "SaoTomeAndPrincipe",
    SaudiArabia = "SaudiArabia",
    Senegal = "Senegal",
    Serbia = "Serbia",
    Seychelles = "Seychelles",
    SierraLeone = "SierraLeone",
    Singapore = "Singapore",
    Slovakia = "Slovakia",
    Slovenia = "Slovenia",
    SolomonIslands = "SolomonIslands",
    Somalia = "Somalia",
    SouthAfrica = "SouthAfrica",
    SouthSudan = "SouthSudan",
    Spain = "Spain",
    SriLanka = "SriLanka",
    Sudan = "Sudan",
    Suriname = "Suriname",
    Swaziland = "Swaziland",
    Sweden = "Sweden",
    Switzerland = "Switzerland",
    Syria = "Syria",
    Taiwan = "Taiwan",
    Tajikistan = "Tajikistan",
    Tanzania = "Tanzania",
    Thailand = "Thailand",
    Togo = "Togo",
    Tonga = "Tonga",
    TrinidadAndTobago = "TrinidadAndTobago",
    Tunisia = "Tunisia",
    Turkey = "Turkey",
    Turkmenistan = "Turkmenistan",
    Tuvalu = "Tuvalu",
    Uganda = "Uganda",
    Ukraine = "Ukraine",
    UAE = "UAE",
    UnitedKingdom = "UnitedKingdom",
    UnitedStates = "UnitedStates",
    Uruguay = "Uruguay",
    Uzbekistan = "Uzbekistan",
    Vanuatu = "Vanuatu",
    VaticanCity = "VaticanCity",
    Venezuela = "Venezuela",
    Vietnam = "Vietnam",
    Yemen = "Yemen",
    Zambia = "Zambia",
    Zimbabwe = "Zimbabwe",
}

export class CountryUtils {
    static readonly values = [Country.Afghanistan, Country.Albania, Country.Algeria, Country.Andorra, Country.Angola, Country.AntiguaAndDeps, Country.Argentina, Country.Armenia, Country.Australia, Country.Austria, Country.Azerbaijan, Country.Bahamas, Country.Bahrain, Country.Bangladesh, Country.Barbados, Country.Belarus, Country.Belgium, Country.Belize, Country.Benin, Country.Bhutan, Country.Bolivia, Country.BosniaHerzegovina, Country.Botswana, Country.Brazil, Country.Brunei, Country.Bulgaria, Country.Burkina, Country.Burundi, Country.Cambodia, Country.Cameroon, Country.Canada, Country.CapeVerde, Country.CentralAfricanRep, Country.Chad, Country.Chile, Country.China, Country.Colombia, Country.Comoros, Country.Congo, Country.CostaRica, Country.Croatia, Country.Cuba, Country.Cyprus, Country.CzechRepublic, Country.Denmark, Country.Djibouti, Country.Dominica, Country.DominicanRepublic, Country.EastTimor, Country.Ecuador, Country.Egypt, Country.ElSalvador, Country.EquatorialGuinea, Country.Eritrea, Country.Estonia, Country.Ethiopia, Country.Fiji, Country.Finland, Country.France, Country.Gabon, Country.Gambia, Country.Georgia, Country.Germany, Country.Ghana, Country.Greece, Country.Grenada, Country.Guatemala, Country.Guinea, Country.GuineaBissau, Country.Guyana, Country.Haiti, Country.Honduras, Country.HongKong, Country.Hungary, Country.Iceland, Country.India, Country.Indonesia, Country.Iran, Country.Iraq, Country.Ireland, Country.Israel, Country.Italy, Country.IvoryCoast, Country.Jamaica, Country.Japan, Country.Jordan, Country.Kazakhstan, Country.Kenya, Country.Kiribati, Country.KoreaNorth, Country.KoreaSouth, Country.Kosovo, Country.Kuwait, Country.Kyrgyzstan, Country.Laos, Country.Latvia, Country.Lebanon, Country.Lesotho, Country.Liberia, Country.Libya, Country.Liechtenstein, Country.Lithuania, Country.Luxembourg, Country.Macedonia, Country.Madagascar, Country.Malawi, Country.Malaysia, Country.Maldives, Country.Mali, Country.Malta, Country.MarshallIslands, Country.Mauritania, Country.Mauritius, Country.Mexico, Country.Micronesia, Country.Moldova, Country.Monaco, Country.Mongolia, Country.Montenegro, Country.Morocco, Country.Mozambique, Country.Myanmar, Country.Namibia, Country.Nauru, Country.Nepal, Country.Netherlands, Country.NewZealand, Country.Nicaragua, Country.Niger, Country.Nigeria, Country.Norway, Country.Oman, Country.Pakistan, Country.Palau, Country.Panama, Country.PapuaNewGuinea, Country.Paraguay, Country.Peru, Country.Philippines, Country.Poland, Country.Portugal, Country.Qatar, Country.Romania, Country.RussianFederation, Country.Rwanda, Country.StKittsAndNevis, Country.StLucia, Country.SaintVincentAndTheGrenadines, Country.Samoa, Country.SanMarino, Country.SaoTomeAndPrincipe, Country.SaudiArabia, Country.Senegal, Country.Serbia, Country.Seychelles, Country.SierraLeone, Country.Singapore, Country.Slovakia, Country.Slovenia, Country.SolomonIslands, Country.Somalia, Country.SouthAfrica, Country.SouthSudan, Country.Spain, Country.SriLanka, Country.Sudan, Country.Suriname, Country.Swaziland, Country.Sweden, Country.Switzerland, Country.Syria, Country.Taiwan, Country.Tajikistan, Country.Tanzania, Country.Thailand, Country.Togo, Country.Tonga, Country.TrinidadAndTobago, Country.Tunisia, Country.Turkey, Country.Turkmenistan, Country.Tuvalu, Country.Uganda, Country.Ukraine, Country.UAE, Country.UnitedKingdom, Country.UnitedStates, Country.Uruguay, Country.Uzbekistan, Country.Vanuatu, Country.VaticanCity, Country.Venezuela, Country.Vietnam, Country.Yemen, Country.Zambia, Country.Zimbabwe]
    static valueOf = (value: string) => CountryUtils.values.find(enumValue => enumValue === value)
    static sort = (value: Country[]) => sortBy(value, expansion => CountryUtils.values.indexOf(expansion))
}